// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"c8a16897","126":"3d868dbd","146":"f3fb67d9","170":"fab830cf","256":"9be9aee9","298":"383cac68","350":"30b777bc","453":"de5f962c","536":"8cc0af84","685":"c30b14fe","688":"9f915c71","725":"bc6a4709"}[chunkId] + ".chunk.js";
};